// Nhãn chi nhánh "Mã - Tên"; thiếu mã thì chỉ hiện tên
export const branchLabel = (code?: string | null, name?: string | null) =>
  [code, name].filter(Boolean).join(" - ");
